import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { UserRegNewWithMobApi } from "../../ApiServices/My Profile/MyProfileApi";
import DatePicker from "react-date-picker";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
// import { ERROR_MESSAGES } from "../GlobalErrorMessage";
import { GetUserModel } from "../../ApiServices/Profile/ProfileApi";
import toast from "react-hot-toast";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import { AddParterForm } from "../../ApiServices/BecomeParterAPI/BecomePartnerAPI";
import SuccessModal from "../../Components/SuccessModal";
import contactImg1 from "../../assets/images/shapes/contact-1-shape-2.png";
import ContactUS from "../../assets/images/new/AboutUS.png";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import WhyChooseUs from "../../Components/WhyChooseUs/WhyChooseUs";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { customSelectStyles } from "../../middlewares/Utils";
import { CountryLookupList } from "../../ApiServices/Other/StateLookupListApi";
import shape2 from "../../assets/images/shapes/service-bg-shape-2-rtl.png";
import { Helmet } from "react-helmet-async";
import { FaUserCheck } from "react-icons/fa";
import { LanguageList } from "../../ApiServices/DailyPanditAPI/DailyPanditApi";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Optional: install react-icons
import ErrorMassagePupUp from "../../Components/ErrorMassagePupUp";
import PartnerApp from "../../Components/DownLoadApp/PartnerApp";

const BecomeAPanditWhyChooseUs = [
  {
    title: "Regular Puja Bookings",
    description:
      "Never worry about finding devotees, we connect you with genuine puja requests regularly so your skills are always in demand.",
    icon: <FaUserCheck size={40} color="#8f3246" />,
  },
  {
    title: "Trusted by Thousands",
    description:
      "Join a platform trusted by devotees nationwide, ensuring your expertise reaches those who value authentic Vedic rituals.",
    icon: <FaUserCheck size={40} color="#8f3246" />,
  },
  {
    title: "Easy Registration Process",
    description:
      "No lengthy paperwork, just share basic details and start receiving puja opportunities in your area easily.",
    icon: <FaUserCheck size={40} color="#8f3246" />,
  },
  {
    title: "Fair & Transparent Earnings",
    description:
      "Get fair compensation for your services with clear payment terms, so you focus on rituals, not negotiations. ",
    icon: <FaUserCheck size={40} color="#8f3246" />,
  },

  {
    title: "Dedicated Support Team",
    description:
      "Our team handles bookings, queries, and logistics, allowing you to concentrate on performing pujas with devotion.",
    icon: <FaUserCheck size={40} color="#8f3246" />,
  },

  {
    title: "Grow Your Spiritual Reach",
    description:
      "Expand your influence as more devotees discover your services through our trusted and widespread network.",
    icon: <FaUserCheck size={40} color="#8f3246" />,
  },
];
const BecomePandit = () => {
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { setLoader, pujaStatus } = useContext(LoaderContext);
  const [errorMessage, setErrorMessage] = useState();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [countryLookupList, setCountryLookupList] = useState([]);
  const [becomePanditFormData, setBecomePanditForm] = useState({
    fullName: null,
    mobileNumber: null,
    email: null,
    address: null,
    dob: null,
    experience: null,
    pujaCount: null,
    country: null,
    pujaType: null,
    password: null,
    LANG_IDS: null,
    DAILY_PANDIT: "Yes",
    PANDIT_TYPE: null,
    NoOfPuja: null,
    password: null

  });
  const ItemAddedToast = () =>
    toast.success(
      "Data added successfully, our team will reach out to you soon!"
    );
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [contactUsMsg, setContactUsMsg] = useState(false);
  const [languageOption, setLanguageOption] = useState([]);
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(null);
  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

  const [showPassword, setShowPassword] = useState(false);
  const data = {
    headerName: "Register As A Pandit",
    sectionTitle: "Book an Experienced Pandit for Your Puja",
    howItWorksMainHeading: "Become a Partner With Us Today",
    howItWorks: [
      {
        howItWorksTitle: "Simple Registration",
        howItWorksDesc:
          "Share basic details like name, experience, language, and country. No documents needed—just your expertise to begin your spiritual journey with us.",
      },
      {
        howItWorksTitle: "Profile Verification",
        howItWorksDesc:
          "Our team reviews your details to ensure authenticity. Once approved, your profile goes live for devotees to find you easily. ",
      },
      {
        howItWorksTitle: "Download App",
        howItWorksDesc:
          "Download our app for faster onboarding. Register in minutes, update your availability, and accept puja requests with ease.",
      },
      // {
      //   howItWorksTitle: "Daily Puja",
      //   howItWorksDesc:
      //     "Register as a Pandit for daily puja requests. Expand your spiritual service and connect with devotees seamlessly.",
      // },
    ],

    FaqObj: [
      {
        question: "How do I register as a Pandit on Myomnamo?",
        answer:
          "Simply fill out our online form with your basic details, experience, and location. No documents needed. We'll verify and activate your profile quickly.",
        color: "#ffa415",
      },
      {
        question: "Will I get regular puja bookings?",
        answer:
          " Yes, we connect you with genuine devotees in your area. The more available you are, the more bookings you can receive.",
        color: "#fc5528",
      },
      {
        question: "How are payments handled?",
        answer:
          "You receive fair payment for each puja. We ensure timely transfers after successful completion, with clear details for every transaction.",
        color: "#8139e7",
      },
      {
        question: "Can I choose the type of pujas I perform?",
        answer:
          "Absolutely. You can specify your expertise (weddings, house pujas, etc.) so we only assign rituals matching your skills.",
        color: "#8139e7",
      },
      {
        question: "What support does Myomnamo provide?",
        answer:
          "We manage bookings, customer queries, and logistics. You focus on performing pujas while we handle the rest for a hassle-free experience.",
        color: "#8139e7",
      },
    ],
    metaTitle: "Register as a Pandit and Become a Partner with Myomnamo",
    metaDescription:
      "Register as a Pandit & connect with devotees needing authentic rituals. No paperwork, regular bookings & trusted platform. Start your spiritual service today!",
    cannonicalLink: "https://www.myomnamo.com/become-pandit",

    metaData: {
      title: "Register as a Pandit and Become a Partner with Myomnamo",
      description:
        "Register as a Pandit & connect with devotees needing authentic rituals. No paperwork, regular bookings & trusted platform. Start your spiritual service today!",
      image: "https://www.myomnamo.com/assets/images/new/logo.png",
      url: "https://www.myomnamo.com/become-pandit",
      siteName: "Myomnamo",
      locale: "en_IN",
    },
    mainContent:
      "At Myomnamo, we honor and support learned Pandits who dedicate their lives to preserving Vedic traditions. If you are a knowledgeable and experienced Purohit, we invite you to register with us and become part of a trusted network that connects you with devotees seeking authentic rituals. We ensure you receive regular puja opportunities, allowing you to focus on your sacred duties while we handle the rest. Our simple registration process requires basic details and documents, so you can start serving with ease.Register with Myomnamo today and let your spiritual expertise reach those in need.",
  };

  useEffect(() => {
    GetStateLookupListData();
  }, []);
  const GetStateLookupListData = async () => {
    try {
      const response = await CountryLookupList(); // Ensure it's correctly imported

      if (response?.ResponseCode === "0") {
        const LIST = response?.DATA || [];

        const formattedLangList = LIST.map((Lang) => ({
          value: Lang.COUNTRY_ID,
          label: Lang.COUNTRY_NAME,
        }));

        setCountryLookupList(formattedLangList);
      } else {
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching sim Type lookup list:", error);
    }
  };


  const handleLanguageChange = (selectedValues) => {
    const langIds = selectedValues.map((item) => item.value).join(",");
    setBecomePanditForm((prev) => ({
      ...prev,
      LANG_IDS: langIds,
    }));
  };

  const handleFormSubmit = () => {
    // debugger;
    let isValid = false;

    if (
      becomePanditFormData.fullName === null ||
      becomePanditFormData.fullName === undefined ||
      becomePanditFormData.fullName === "" ||
      becomePanditFormData.mobileNumber === null ||
      becomePanditFormData.mobileNumber === undefined ||
      becomePanditFormData.mobileNumber === "" ||
      becomePanditFormData.address === "" ||
      becomePanditFormData.address === null ||
      becomePanditFormData.address === undefined ||
      becomePanditFormData.email === "" ||
      becomePanditFormData.email === null ||
      becomePanditFormData.email === undefined ||
      becomePanditFormData.pujaCount === "" ||
      becomePanditFormData.pujaCount === null ||
      becomePanditFormData.pujaCount === undefined ||
      becomePanditFormData.experience === null ||
      becomePanditFormData.experience === undefined ||
      becomePanditFormData.experience === "" ||
      becomePanditFormData.LANG_IDS === null ||
      becomePanditFormData.LANG_IDS === undefined ||
      becomePanditFormData.LANG_IDS === "" ||
      becomePanditFormData.dob === null ||
      becomePanditFormData.dob === undefined ||
      becomePanditFormData.dob === "" ||
      becomePanditFormData.password === null ||
      becomePanditFormData.password === undefined ||
      becomePanditFormData.password === "" ||
      becomePanditFormData.mobileNumber?.length < 10
    ) {
      setError(true);
      isValid = true;
    } else if (
      becomePanditFormData.email &&
      !isValidEmail(becomePanditFormData.email)
    ) {
      setError(true);
      isValid = true;
    } else if (becomePanditFormData.password !== null &&
      becomePanditFormData.password !== undefined &&
      becomePanditFormData.password !== "" && becomePanditFormData.password?.length < 8) {
      setError(true);
      isValid = true;
    }

    const apiParam = {
      DOB: becomePanditFormData.dob,
      FullName: becomePanditFormData.fullName,
      Address: becomePanditFormData.address,
      MobileNo: becomePanditFormData.mobileNumber,
      NoOfPuja: becomePanditFormData.pujaCount,
      ExpInYears: becomePanditFormData.experience,
      email: becomePanditFormData.email,
      PANDIT_TYPE: "Pandit",
      DAILY_PANDIT: becomePanditFormData.DAILY_PANDIT,
      LANG_IDS: becomePanditFormData.LANG_IDS,
      Password: becomePanditFormData?.password

    };
    // return isValid;
    if (!isValid) {
      console.log("apiParam", apiParam);
      AddUpdateBecomePanditData(apiParam);
    }
  };

  const AddUpdateBecomePanditData = async (apiParam) => {

    setLoader(true);
    try {
      // let url = `/UserRegNewWithMob?USER_ID=${userID}`;

      const response = await AddParterForm(apiParam);
      if (response) {
        if (response?.ResponseCode == 0) {
          setLoader(false);

          navigate("/thank-you", {
            state: { moduleName: "PanditRegister" },
          });
        } else {
          console.log("api not call");
          setLoader(false);
          setErrorMessage(response?.ResponseMessage);
          setShowErrorModal(true)
        }
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleDateChange = (date) => {
    setBecomePanditForm((prevState) => ({
      ...prevState,
      dob: date, // Update state with selected date
    }));
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const setInitialData = () => {
    setError(false);
    setBecomePanditForm((prevState) => ({
      ...prevState,
      fullName: null,
      mobileNumber: null,
      email: null,
      address: null,
      dob: null,
      experience: null,
      pujaCount: null,
      PANDIT_TYPE: null
    }));
  };
  const closeAll = () => {
    // debugger;
    setShowSuccessPopUp(false);
    setInitialData();
  };


  useEffect(() => {
    GetLanguageListLookupListData()
  }, [])
  const GetLanguageListLookupListData = async () => {
    setLoader(true);
    try {
      const response = await LanguageList(); // Ensure it's correctly imported

      if (response?.ResponseCode === "0") {
        setLoader(false);

        const languageLookupList = response?.DATA || [];
        const formattedLangList = languageLookupList.map((Lang) => ({
          value: Lang.LANG_ID,
          label: Lang.LANG_NAME,
        }));

        setLanguageOption(formattedLangList);
      } else {
        setLoader(false);
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching sim Type lookup list:", error);
    }
  };
  return (
    <>
      <Helmet>
        <title>{data.metaTitle}</title>
        <meta name="description" content={data.metaDescription} />
        <link rel="canonical" href={data.cannonicalLink} />

        {/* Open Graph tags */}
        <meta property="og:title" content={data.metaData.title} />
        <meta property="og:description" content={data.metaData.description} />
        <meta property="og:image" content={data.metaData.image} />
        <meta property="og:url" content={data.metaData.url} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={data.metaData.siteName} />
        <meta property="og:locale" content={data.metaData.locale || "en_IN"} />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={data.metaData.title} />
        <meta name="twitter:description" content={data.metaData.description} />
        <meta name="twitter:image" content={data.metaData.image} />
      </Helmet>
      <section className="page-header">
        <div className="page-header__bg"></div>
        <div className="container">
          <h2 className="page-header__title bw-split-in-left">
            Register As A Pandit
          </h2>
        </div>
      </section>
      <section
        className="contact-one contact-one--page"
        style={{ padding: "25px 0 0 0" }}
      >
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="about-one__image__one">
              <img
                src={ContactUS}
                style={{
                  height: "490px",
                  width: "467px",
                  objectFit: "contain",
                }}
                alt="contact"
              />
            </div>
          </div>
          <div className="col-md-6 ">
            <div className="card-body" style={{ marginLeft: "12px" }}>
              <h6 className="sec-title__tagline bw-split-in-right">
                <img className=" tagline-img" src={batuk} alt="" /> Partner
                Registration
              </h6>
              <h3 className="sec-title__title bw-split-in-left">
                Let’s Talk! Register Today
              </h3>
              <p className="contact-one__text">
                Register with Myomnamo and get regular puja bookings. Download
                our app, complete your profile, and become a trusted spiritual
                partner today!
              </p>
              <div className="card p-3" style={{ marginRight: '25px' }} >
                <div className="row gy-3 ">
                  <div className="col-md-6 ">
                    <label className="form-label fw-light labelFontSize">
                      Full Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-form-control rounded-3"
                      placeholder="Enter Full Name"
                      value={becomePanditFormData.fullName || ''}
                      autoComplete="off"

                      onChange={(e) => {
                        setErrorMessage("");
                        let inputVal = e.target.value;
                        if (inputVal.startsWith(" ")) {
                          inputVal = inputVal.trimStart();
                        }
                        setBecomePanditForm((obj) => ({
                          ...obj,
                          fullName: inputVal,
                        }));
                      }}
                    />
                    {(error && becomePanditFormData.fullName === null) ||
                      becomePanditFormData.fullName === undefined ||
                      becomePanditFormData.fullName === "" ? (
                      <span className="error-msg">{ERROR_MESSAGES}</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-md-6 d-flex flex-column">
                    <label className="form-label fw-light labelFontSize">
                      Date Of Birth <span className="text-danger">*</span>
                    </label>

                    <DatePicker
                      id="bookingDate"
                      value={becomePanditFormData?.dob || null}
                      clearIcon={null}
                      onChange={handleDateChange}
                      format="dd/MM/yyyy"
                      className="custom-date-picker"
                      style={{ paddingBottom: '5px' }}
                      maxDate={maxDate}

                      dayPlaceholder="DD"
                      monthPlaceholder="MM"
                      yearPlaceholder="YYYY"


                    />

                    {/* <DatePicker
                    value={becomePanditFormData?.dob}
                    onChange={handleDateChange}
                    clearIcon={null}
                    popperPlacement="bottom-end"
                    format="dd-MM-yyyy"
                    className="custom-custom-form-control"
                  /> */}
                    {(error && becomePanditFormData.dob === null) ||
                      becomePanditFormData.dob === undefined ||
                      becomePanditFormData.dob === "" ? (
                      <span className="error-msg">This field is required</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="row gy-3">
                  <div className="col-md-6">
                    <label className="form-label fw-light labelFontSize">
                      Mobile Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-form-control rounded-3"
                      maxLength={10}
                      placeholder="Enter Mobile Number"
                      value={becomePanditFormData.mobileNumber}
                      onChange={(e) => {
                        setErrorMessage("");
                        let formattedNumber = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        formattedNumber = formattedNumber.replace(/^[0-5]/, "");
                        setBecomePanditForm((prev) => ({
                          ...prev,
                          mobileNumber: formattedNumber,
                        }));
                      }}
                    />
                    {(error && becomePanditFormData.mobileNumber === null) ||
                      becomePanditFormData.mobileNumber === undefined ||
                      becomePanditFormData.mobileNumber === "" ? (
                      <span className="error-msg">{ERROR_MESSAGES}</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-light labelFontSize">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-form-control rounded-3"
                      placeholder="Enter Email"
                      value={becomePanditFormData.email}
                      onChange={(e) => {
                        let inputVal = e.target.value;
                        if (inputVal.startsWith(" ")) {
                          inputVal = inputVal.trimStart();
                        }
                        setBecomePanditForm((obj) => ({
                          ...obj,
                          email: inputVal,
                        }));
                      }}
                    />
                    {(error && becomePanditFormData.email === null) ||
                      becomePanditFormData.email === undefined ||
                      becomePanditFormData.email === "" ? (
                      <span className="error-msg">{ERROR_MESSAGES}</span>
                    ) : error && !isValidEmail(becomePanditFormData.email) ? (
                      <span className="error-msg">
                        Please enter valid email address
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {/* <div className="row gy-3">

                <div className="col-md-6">
                  <label className="form-label fw-light labelFontSize">
                    Country <span className="text-danger">*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={countryLookupList}
                    onChange={(selectedOption) => {
                      setBecomePanditForm((prev) => ({
                        ...prev,
                        country: selectedOption?.value,
                      }));
                    }}
                    value={countryLookupList.find(
                      (item) => item.value === becomePanditFormData?.country
                    )}
                  />
                  {(error && becomePanditFormData.country === null) ||
                    becomePanditFormData.country === undefined ||
                    becomePanditFormData.country === "" ? (
                    <span className="error-msg">{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>


                <div className="col-md-6">
                  <label className="form-label fw-light labelFontSize">
                    Puja Type <span className="text-danger">*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={countryLookupList}
                    onChange={(selectedOption) => {
                      setBecomePanditForm((prev) => ({
                        ...prev,
                        country: selectedOption?.value,
                      }));
                    }}
                    value={countryLookupList.find(
                      (item) => item.value === becomePanditFormData?.country
                    )}
                  />
                  {(error && becomePanditFormData.experience === null) ||
                    becomePanditFormData.experience === undefined ||
                    becomePanditFormData.experience === "" ? (
                    <span className="error-msg">This field is required</span>
                  ) : (
                    ""
                  )}
                </div>
              </div> */}
                <div className="row gy-3">
                  <div className="col-md-6">
                    <label className="form-label fw-light labelFontSize">
                      Number of Puja's <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-form-control rounded-3"
                      maxLength={5}
                      placeholder="Enter Number of Puja's"
                      value={becomePanditFormData.pujaCount}
                      onChange={(e) => {
                        setErrorMessage("");
                        let inputVal = e.target.value;

                        // Allow only digits (no letters or special characters)
                        if (/^\d*$/.test(inputVal)) {
                          setBecomePanditForm((prev) => ({
                            ...prev,
                            pujaCount: inputVal,
                          }));
                        }
                      }}
                    />
                    {(error && becomePanditFormData.pujaCount === null) ||
                      becomePanditFormData.pujaCount === undefined ||
                      becomePanditFormData.pujaCount === "" ? (
                      <span className="error-msg">This field is required</span>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-light labelFontSize">
                      Experience (In Years) <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-form-control rounded-3"
                      maxLength={2}
                      placeholder="Enter Experience"
                      value={becomePanditFormData.experience}
                      onChange={(e) => {
                        setErrorMessage("");
                        let inputVal = e.target.value;
                        inputVal = inputVal.replace(/\D/g, "");
                        // Allow only digits (no letters or special characters)
                        setBecomePanditForm((prev) => ({
                          ...prev,
                          experience: inputVal,
                        }));
                      }}
                    />
                    {(error && becomePanditFormData.experience === null) ||
                      becomePanditFormData.experience === undefined ||
                      becomePanditFormData.experience === "" ? (
                      <span className="error-msg">This field is required</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="row gy-3">
                  <div className="col-md-6">
                    <label className="form-label fw-light labelFontSize">
                      Select Language <span className="text-danger">*</span>
                    </label>
                    <Select
                      isMulti
                      options={languageOption}
                      onChange={handleLanguageChange}
                      value={languageOption.filter((item) =>
                        becomePanditFormData.LANG_IDS?.split(",").includes(item.value.toString())
                      )}
                      menuPlacement="top"
                      styles={customSelectStyles}
                    />

                    {(error && becomePanditFormData.LANG_IDS === null) ||
                      becomePanditFormData.LANG_IDS === undefined ||
                      becomePanditFormData.LANG_IDS === "" ? (
                      <span className="error-msg">This field is required</span>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-light labelFontSize">
                      Daily Pandit  <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-4 mt-2">
                      <div className="form-check">
                        <input
                          type="radio"
                          name="dailyPandit"
                          value="Yes"
                          checked={becomePanditFormData.DAILY_PANDIT === "Yes"}
                          onChange={(e) =>
                            setBecomePanditForm((prev) => ({
                              ...prev,
                              DAILY_PANDIT: e.target.value,
                            }))
                          }

                          id="dailyPanditYes"
                          style={{
                            accentColor: '#a52444',
                            width: '1rem',
                            height: '1rem',
                            cursor: 'pointer',
                            marginRight: '10px'
                          }}
                        />
                        <label className="form-check-label" htmlFor="dailyPanditYes">
                          Yes
                        </label>
                      </div>

                      <div className="form-check">
                        <input
                          type="radio"
                          name="dailyPandit"
                          value="No"
                          checked={becomePanditFormData.DAILY_PANDIT === "No"}
                          onChange={(e) =>
                            setBecomePanditForm((prev) => ({
                              ...prev,
                              DAILY_PANDIT: e.target.value,
                            }))
                          }
                          // className="form-check-input"
                          id="dailyPanditNo"
                          style={{
                            accentColor: '#a52444',
                            width: '1rem',
                            height: '1rem',
                            cursor: 'pointer',
                            marginRight: '10px'

                          }}
                        />
                        <label className="form-check-label" htmlFor="dailyPanditNo">
                          No
                        </label>
                      </div>
                    </div>


                  </div>
                </div>

                <div className="row gy-3" style={{ justifyContent: "left" }}>
                  <div className="col-md-6">
                    <label className="form-label fw-light labelFontSize">
                      Address <span className="text-danger">*</span>
                    </label>
                    <textarea
                      type="text"
                      className="custom-form-control rounded-3"
                      maxLength={200}
                      placeholder="Enter Address"
                      value={becomePanditFormData.address}
                      onChange={(e) => {
                        setErrorMessage("");
                        let inputVal = e.target.value;
                        if (inputVal.startsWith(" ")) {
                          inputVal = inputVal.trimStart();
                        }
                        setBecomePanditForm((prev) => ({
                          ...prev,
                          address: inputVal,
                        }));
                      }}
                    />
                    {(error && becomePanditFormData.address === null) ||
                      becomePanditFormData.address === undefined ||
                      becomePanditFormData.address === "" ? (
                      <span className="error-msg">This field is required</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-md-6 position-relative">
                    <label className="form-label fw-light labelFontSize">
                      Enter Password <span className="text-danger">*</span>
                    </label>

                    <div className="position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="custom-form-control rounded-3 pe-5"
                        maxLength={20}
                        placeholder="Enter Password"
                        value={becomePanditFormData.password}
                        onChange={(e) => {
                          setErrorMessage(false);
                          let inputVal = e.target.value;
                          if (inputVal.startsWith(" ")) {
                            inputVal = inputVal.trimStart();
                          }
                          setBecomePanditForm((prev) => ({
                            ...prev,
                            password: inputVal,
                          }));
                        }}
                      />

                      <span
                        className="position-absolute top-50 end-0 translate-middle-y me-3"
                        style={{ cursor: "pointer", zIndex: 10 }}
                        onClick={() => setShowPassword((prev) => !prev)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>

                    {(error && becomePanditFormData.password === null) ||
                      becomePanditFormData.password === undefined ||
                      becomePanditFormData.password === "" ? (
                      <span className="error-msg">This field is required</span>
                    ) : (
                      error &&
                      becomePanditFormData.password &&
                      becomePanditFormData.password.length < 8 && (
                        <span className="error-msg">Password must be more than or equal to 8 characters</span>
                      )
                    )}
                  </div>
                </div>
                {/* Submit Button */}
                <div className="d-flex justify-content-left mt-4">
                  <button
                    className="Normal-app-btn"
                    style={{ fontSize: "16px" }}
                    onClick={() => handleFormSubmit()}
                  >
                    Submit
                  </button>
                </div>
              </div>



            </div>
          </div>
        </div>

        <SuccessModal
          Action={"Contact"}
          show={showSuccessPopUp}
          onHide={() => setShowSuccessPopUp(false)}
          setContactUsMsg={setContactUsMsg}
          contactUsMsg={contactUsMsg}
          onConfirm={closeAll}
        // Action={Action}
        />
      </section>
      {/* How it works */}

      <section className="service-one mt-4" style={{ padding: "30px 0" }}>
        <div
          className="service-one__shape-two"
          style={{ backgroundImage: `url(${shape2})` }}
        ></div>
        <div
          className="container"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="row">
            <div className="col-12">
              <div
                className="sec-title text-center"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <h6 className="sec-title__tagline bw-split-in-right">
                  <img className=" tagline-img" src={batuk} alt="" />
                  How It Works{" "}
                </h6>

                <h3 className="sec-title__title bw-split-in-left">
                  {data.howItWorksMainHeading}
                </h3>
              </div>
              <div
                class="row gutter-y-30 d-flex align-center justify-center"
                style={{ gap: "20px", justifyContent: 'center' }}
              >
                {data.howItWorks?.map((item, index) => (
                  <div
                    className="col-lg-3 col-md-6 wow fadeInUp"
                    data-wow-delay="00ms"
                  >
                    <div
                      className="service-one__item text-center d-flex flex-column h-100"
                    // style={{ color: "#a42642" }}
                    >
                      <div className="service-one__item__icon">
                        <img src={batuk} alt="careox" height={50} width={50} />
                      </div>
                      <h3
                        className="service-one__item__title"
                        style={{ textAlign: "center" }}
                      >
                        {item?.howItWorksTitle}
                      </h3>
                      <p
                        className="service-one__item__text flex-grow-1"
                        style={{ textAlign: "left", fontFamily: "Poppins" }}
                      >
                        {item?.howItWorksDesc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why choose us */}

      <section
        className="py-5 text-center"
        style={{ backgroundColor: "#f1f6f7" }}
      >
        <div
          className="container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h6
            className="sec-title__tagline bw-split-in-right"
            style={{ color: "#A52444" }}
          >
            <img className=" tagline-img" src={batuk} alt="" />
            Why Choose Us
          </h6>

          <h3 className="sec-title__title bw-split-in-left">
            Register now and let your divine service flourish with Myomnamo.
          </h3>

          <div
            className="d-flex flex-wrap justify-content-center"
            style={{
              gap: "30px", // Increase this value for more space
              padding: "20px",
            }}
          >
            {BecomeAPanditWhyChooseUs.map((reason, index) => (
              <div
                key={index}
                className="card shadow-sm border-0 p-4 text-center"
                style={{
                  width: "320px", // Adjust width as needed
                  minHeight: "300px", // Optional: for uniform height
                }}
              >
                <div className="mb-3">{reason.icon}</div>
                <h5 className="fw-bold mb-2">{reason.title}</h5>
                <p style={{ textAlign: "left" }}>{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* <WhyChooseUs /> */}
      <PartnerApp />
      <ErrorMassagePupUp show={showErrorModal} onHide={() => setShowErrorModal(false)} Massage={errorMessage} />
    </>
  );
};

export default BecomePandit;
